const itemDataML = [
  {
    img: 'https://images.unsplash.com/photo-1549837019-c0739c157eb8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzR8fHBhcmFwZW50ZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne',
  },
  {
    img: 'https://images.unsplash.com/photo-1644777396284-7f0c0daf32f6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzZ8fHBhcmFwZW50ZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne2',
  },
  {
    img: 'https://images.unsplash.com/photo-1644777375758-14a44f7d3bca?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzd8fHBhcmFwZW50ZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne3',
  },
  {
    img: 'https://images.unsplash.com/photo-1614690440908-b5a1787fdd1a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzl8fHBhcmFwZW50ZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
    title: 'montagne4',
  },

];
export default itemDataML;
